module.exports = __webpack_public_path__ + "img/tooltip.5c3e065d.png";